// extracted by mini-css-extract-plugin
module.exports = {"testimonialsContainer":"styles-module--testimonialsContainer--30byG","quoteStyles":"styles-module--quoteStyles--2LGmh"};